import { Heading } from "@digdir/designsystemet-react";
import "./CustomLegend.css";

type CustomLegendProps = {
    heading: string;
    children: React.ReactNode;
};

export const CustomLegend: React.FC<CustomLegendProps> = ({ heading, children }) => {
    return (
        <div className="custom-legend-container">
            <Heading level={4} data-size="xs">
                {heading}
            </Heading>

            <div className="custom-legend">{children}</div>
        </div>
    );
};
